module.exports = __webpack_public_path__ + "static/bg-wedding-5dbfbbafc2e0d9bc1ed1a7c79b83c284.webp";